import * as tslib_1 from "tslib";
import { NoPassLoginStartUrl, NoPassLoginFinishUrl, NoPassListDevicesURL, NoPassDeleteDeviceURL } from '../constants';
const RequestHeaders = {
    headers: { Accept: 'application/json' },
};
export function nopass(api) {
    return {
        loginStart: (username) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield api.post(`${NoPassLoginStartUrl}?username=${username}`, {}, RequestHeaders);
        }),
        loginFinish: (authId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api.get(NoPassLoginFinishUrl, { authid: authId }, RequestHeaders);
        }),
        getDevices: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api.authenticated().get(NoPassListDevicesURL, {}, RequestHeaders);
        }),
        deleteDevice: (deviceId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api.authenticated().post(NoPassDeleteDeviceURL(deviceId), {}, RequestHeaders);
        }),
        getAuthHistory: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api.authenticated().get(NoPassListDevicesURL, {}, RequestHeaders);
        }),
    };
}
//# sourceMappingURL=nopass.js.map